import { AppModel } from '../models';
import { AppActionTypes, AppLanguageAction } from '../actions/app.actions';

const initialState: AppModel = {
  language: null,
};

export type AppActions = AppLanguageAction;

export function appReducer(state: AppModel = initialState, action: AppActions): AppModel {
  switch (action.type) {
    case AppActionTypes.Language:
      return {
        ...state,
        language: action.data,
      };
    default:
      return state;
  }
}
